import { render } from "./FatturazionePage.vue?vue&type=template&id=ccc946bc&scoped=true"
import script from "./FatturazionePage.vue?vue&type=script&lang=js"
export * from "./FatturazionePage.vue?vue&type=script&lang=js"

import "./FatturazionePage.vue?vue&type=style&index=0&id=ccc946bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccc946bc"]])

export default __exports__